module.exports = __webpack_public_path__ + "static/media/loginRotation4.9cfa078f.jpg";